import * as actionTypes from './actionTypes'
import * as requestActionTypes from '../Request/actionTypes'
import { get } from 'lodash'
import { CMSComponentSchema } from 'helpers/cms'

export type CMSStateType = {
  cms: Array<CMSComponentSchema>
}

const initialState = (): CMSStateType => ({
  cms: [],
})

const CMSReducer = (state = initialState(), action: ActionType) => {
  switch (action.type) {
    case requestActionTypes.SUCCEEDED:
      switch (action.meta.sourceType) {
        case actionTypes.CMS_DATA_REQUESTED: {
          return {
            ...state,
            cms: get(action.payload.result, 'body', []),
          }
        }
        default:
          return state
      }

    default:
      return state
  }
}

export default CMSReducer
